import { WorkspaceLayoutPane } from "../DataWorkspace/utils"
import { useMemo } from "react"
import { getPaneAtom } from "@/store/workspaceAtoms"
import { useAtomValue } from "jotai"


const MinimizeIcon = ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1">
        <line x1="2" y1="12" x2="14" y2="12" strokeLinecap="round" />
    </svg>
)

interface MinimizePaneProps {
    onClick: () => void
    paneKey: WorkspaceLayoutPane
}

const PaneDependencyMap: Record<WorkspaceLayoutPane, WorkspaceLayoutPane[]> = {
    assignment: ['solution'],
    solution: ['assignment'],
    schema: ['queryHistory', 'query', 'queryOutput'],
    queryHistory: ['schema', 'query', 'queryOutput'],
    query: ['schema', 'queryHistory', 'queryOutput'],
    queryOutput: ['query', 'schema', 'queryHistory'],
    top: [],
    bottom: [],
}

export const MinimizePane = ({ onClick, paneKey }: MinimizePaneProps) => {
    const depsAtoms = useMemo(() => PaneDependencyMap[paneKey].map(dependency => getPaneAtom(dependency)), [paneKey])
    const depsStates = depsAtoms.map(atom => useAtomValue(atom))
    return depsStates.some(state => state) ? (
        <button
            className="p-1.5 rounded hover:bg-secondary/70 transition-colors flex-shrink-0"
            aria-label="Minimize"
            title="Minimize"
            onClick={onClick}
            data-tour-id="minimize-pane"
        >
            <MinimizeIcon className="w-4 h-4" />
        </button>
    ) : null
}